import React, { Component } from "react";
import MessageA1 from "../MessageCodes/MessageA1";
import MessageA2 from "../MessageCodes/MessageA2";
import MessageA13 from "../MessageCodes/MessageA13";
import MessageA5 from "../MessageCodes/MessageA5";
import MessageA6 from "../MessageCodes/MessageA6";
import MessageA14 from "../MessageCodes/MessageA14";
import MessageA15 from "../MessageCodes/MessageA15";
import MessageA19 from "../MessageCodes/MessageA19";
import MessageA20 from "../MessageCodes/MessageA20";
import MessageA21 from "../MessageCodes/MessageA21";
import MessageA3 from "../MessageCodes/MessageA3";
import Redirect from "../MessageCodes/Redirect";

class CustomMessage extends Component {

    render() {
        let messageEntries = (this.props.message.message.chatResponse && this.props.message.message.chatResponse.entries) || [];
        let sentTimestamp  = this.props.message.message.sentTimestamp;
        return (
            <>
                {messageEntries.map((entry, index, allEntries) => {
                    return this.getMessageComponent(entry, index, (allEntries.length === index), sentTimestamp);
                })}
            </>
        )
    }

    // "uiCommand": "A1",
    // "text": "Text(A3)",
    // "keyword": "1",
    // "code": "1.1"

    getMessageComponent = (entry, index, isLastEntry, sentTimestamp) => {
        let commandType = entry.uiCommand;
    
        switch (commandType) {
           
            case UICommandType.A1: return <MessageA1 key={"message-a1-" + index} entry={entry} entryIndex={index}   isLastEntry={isLastEntry} sentTimestamp={sentTimestamp} {...this.props} />
            case UICommandType.A2: return <MessageA2  key={"message-a2-" + index} entry={entry} entryIndex={index}  isLastEntry={isLastEntry} sentTimestamp={sentTimestamp} {...this.props} />
            case UICommandType.A3: return <MessageA3  key={"message-a3-" + index} entry={entry} entryIndex={index}  isLastEntry={isLastEntry} sentTimestamp={sentTimestamp} {...this.props} />
            case UICommandType.A5: return <MessageA5  key={"message-a5-" + index} entry={entry} entryIndex={index}  isLastEntry={isLastEntry} sentTimestamp={sentTimestamp} {...this.props} />
            case UICommandType.A6: return <MessageA6  key={"message-a6-" + index} entry={entry} entryIndex={index}  isLastEntry={isLastEntry} sentTimestamp={sentTimestamp} {...this.props} />
            case UICommandType.A13: return <MessageA13  key={"message-a13-" + index} entry={entry} entryIndex={index}  isLastEntry={isLastEntry} sentTimestamp={sentTimestamp} {...this.props} />
            case UICommandType.A14: return <MessageA14 key={"message-a14-" + index} entry={entry} entryIndex={index}  isLastEntry={isLastEntry} sentTimestamp={sentTimestamp} {...this.props} />
            case UICommandType.A15: return <MessageA15  key={"message-a15-" + index} entry={entry} entryIndex={index}  isLastEntry={isLastEntry} sentTimestamp={sentTimestamp} {...this.props} />
            case UICommandType.A19: return <MessageA19  key={"message-a19-" + index} entry={entry} entryIndex={index}  isLastEntry={isLastEntry} sentTimestamp={sentTimestamp} {...this.props} />
            case UICommandType.A20: return <MessageA20  key={"message-a20-" + index} entry={entry} entryIndex={index}  isLastEntry={isLastEntry} sentTimestamp={sentTimestamp} {...this.props} />
            case UICommandType.A21: return <MessageA21  key={"message-a21-" + index} entry={entry} entryIndex={index}  isLastEntry={isLastEntry} sentTimestamp={sentTimestamp} {...this.props} />
            case UICommandType.Redirect: return <Redirect  key={"message-redirect-" + index} entry={entry} entryIndex={index}  isLastEntry={isLastEntry} sentTimestamp={sentTimestamp} {...this.props} />

            // closedSession:"closedSession", 
            // transferSession:"transferSession"
            default: return <></>;
        }
    }


}

export const UICommandType = {
    A1: "A1",
    A2: "A2",
    A3: "A3",
    A5: "A5",
    A6: "A6",
    A10: "A10",
    A13: "A13",
    A14: "A14",
    A15: "A15",
    A19: "A19",
    A20: "A20",
    A21: "A21",
    A24: "A24",
    Redirect:"Redirect",
    closedSession: "closedSession",
    transferSession: "transferSession"
}

export const MessageType = {
    received: "RECEIVED",
    sent: "SENT",
    info: "INFO"
}

export default CustomMessage;
